<template>
  <span
    :class="[
      'tw-box-content tw-font-medium tw-px-2 tw-py-1 tw-text-xs tw-rounded tw-m-[2px]',
      `tw-bg-${color}-light`,
      `tw-text-${color}`
    ]"
  >
    {{ name }}
    <i
      v-if="difficulty == null"
      class="fas fa-spinner fa-spin tw-ml-1"
    />
  </span>
</template>

<script setup>

import {computed} from "vue";

const props = defineProps({
  difficulty: {
    type: [Number, null],
    required: true,
  },
  tiers: {
    type: Object,
    default() {
      return {
        low: 39,
        med: 54,
        high: 74,
        vHigh: 100,
      }
    },
    validator(value) {
      return ['low', 'med', 'high', 'vHigh',].every(prop => Object.keys(value).includes(prop));
    }
  },
})

const color = computed(() => {
  const {difficulty} = props;
  if (difficulty === null) return 'grey';
  if (difficulty <= props.tiers.low) return 'green';
  if (difficulty <= props.tiers.med) return 'whitney';
  if (difficulty <= props.tiers.high) return 'pink';
  return 'denali';
})

const name = computed(() => {
  const {difficulty} = props;
  if (difficulty === null) return 'Fetching data';
  if (difficulty <= props.tiers.low) return 'Low';
  if (difficulty <= props.tiers.low) return 'Low';
  if (difficulty <= props.tiers.med) return 'Medium';
  if (difficulty <= props.tiers.high) return 'High';
  return 'Very High';
});
</script>
